const TaxAwardClubTerm = {
  init: () => {
    const isTaxAwardClub = document.querySelector("body.tax-tax_award_club");
    if (!isTaxAwardClub) return;

    // find all individual expand/collapse btns
    const btns = Array.from(
      document.querySelectorAll(".row-award-member .button")
    );

    if (btns) {
      // activate every individual expand/collapse btn per row
      btns.forEach((btn) => {
        btn.addEventListener("click", function (e) {
          const elTarget = e.target;
          const btn = elTarget.closest(".button");
          TaxAwardClubTerm.expandCollapse(btn);
        });
      });
    }

    // find main btn to expand/collapse ALL data wrappers at once
    const btnAwardsToggle = document.getElementById("btn-awards-toggle");

    // activate main expand/collapse btn to toggle ALL rows
    if (btnAwardsToggle) {
      btnAwardsToggle.addEventListener("click", function () {
        // first toggle the main btn
        TaxAwardClubTerm.expandCollapse(btnAwardsToggle);

        // get all row btns
        const rowBtns = Array.from(
          document.querySelectorAll(".row-award-member .button")
        );

        if (rowBtns) {
          // expand/collapse ALL row btns at once!
          rowBtns.forEach((rowBtn) => {
            TaxAwardClubTerm.expandCollapse(rowBtn);
          });
        }
      });
    }
  },

  expandCollapse: (btn) => {
    if (!btn) return;

    // get btn aria labels
    const labelOpen = btn.dataset.ariaLabelOpen;
    const labelClose = btn.dataset.ariaLabelClose;

    // get btn text values
    const textOpen = btn.dataset.textOpen ? btn.dataset.textOpen : "Visa";
    const textClose = btn.dataset.textClose ? btn.dataset.textClose : "Göm";

    // get btn inner text span element
    const btnText = btn.querySelector(".button__text");

    // toggle aria expanded attr
    let isExpanded = btn.getAttribute("aria-expanded") === "true" || false;
    btn.setAttribute("aria-expanded", !isExpanded);

    // toggle aria labels
    if (!isExpanded) {
      btn.setAttribute("aria-label", labelClose);
      if (btnText) btnText.textContent = textClose;
    } else {
      btn.setAttribute("aria-label", labelOpen);
      if (btnText) btnText.textContent = textOpen;
    }
  },
};

export default TaxAwardClubTerm;
